import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { SimpleImage, Typography } from "@parkschannel/ui";
export const DescriptionSection = (param)=>{
    let { reverse , icon , bgcImg , children , title  } = param;
    return /*#__PURE__*/ _jsxs("section", {
        className: classNames("flex flex-col gap-8 md:gap-5 md:items-center lg:justify-between", {
            "md:flex-row-reverse": reverse,
            "md:flex-row": !reverse
        }),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "w-full lg:max-w-[425px]",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "mb-4 lg:mb-6",
                        children: icon
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h2",
                        className: "text-neutral-800 mb-4 md:mb-2 lg:mb-4",
                        children: title
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "relative w-full h-[313px] overflow-hidden rounded-2xl lg:max-w-[542px] lg:h-[489px]",
                children: /*#__PURE__*/ _jsx(SimpleImage, {
                    src: bgcImg,
                    alt: "".concat(title, " background"),
                    fill: true,
                    className: "object-cover"
                })
            })
        ]
    });
};
